import { useCallback, useEffect, useState } from "react";
import { message } from "antd";
import axAPI from "api/axios-instance";
import {
  HelpfulMaterial,
  HelpfulMaterialFormValues,
  HelpfulMaterialsResponse,
} from "./types";

const MATERIALS_URL = "/cms/medicine/materials/helpful";

export const useHelpfulMaterials = () => {
  const [materials, setMaterials] = useState<HelpfulMaterial[]>([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [removingIds, setRemovingIds] = useState<number[]>([]);

  const loadMaterials = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await axAPI.get<HelpfulMaterialsResponse>(MATERIALS_URL);
      setMaterials(
        [...(data.materials || [])].sort((a, b) => (a.ord ?? 0) - (b.ord ?? 0))
      );
    } catch (error: any) {
      message.error(error?.message || "Не удалось загрузить полезные файлы");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadMaterials();
  }, [loadMaterials]);

  const saveMaterial = async (values: HelpfulMaterialFormValues) => {
    setSaving(true);
    try {
      await axAPI.post(`${MATERIALS_URL}/upsert`, {
        ...values,
        ord: values.ord ?? undefined,
      });
      message.success("Материал сохранен");
      await loadMaterials();
    } catch (error: any) {
      message.error(error?.message || "Не удалось сохранить материал");
      throw error;
    } finally {
      setSaving(false);
    }
  };

  const removeMaterial = async (id: number) => {
    setRemovingIds((state) => [...state, id]);
    try {
      await axAPI.post(`${MATERIALS_URL}/remove/${id}`);
      message.success("Материал удален");
      await loadMaterials();
    } catch (error: any) {
      message.error(error?.message || "Не удалось удалить материал");
    } finally {
      setRemovingIds((state) => state.filter((item) => item !== id));
    }
  };

  return {
    loading,
    materials,
    removingIds,
    saving,
    removeMaterial,
    saveMaterial,
  };
};
